import { render, staticRenderFns } from "./DadosFaculdade.vue?vue&type=template&id=3776b5aa&scoped=true&"
import script from "./DadosFaculdade.vue?vue&type=script&lang=js&"
export * from "./DadosFaculdade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3776b5aa",
  null
  
)

export default component.exports